import { ROLES } from '@/shared/constants/roles';

export const authorsaideRoutes = [
  {
    path: 'author-aide',
    name: 'author-aide',
    component: () => import('./views/AuthorsAideView.vue'),
    meta: { requiredRole: ROLES.INSTRUCTOR },
  },
];
